import { render, staticRenderFns } from "./view-product.vue?vue&type=template&id=2255c978&"
import script from "./view-product.vue?vue&type=script&lang=ts&"
export * from "./view-product.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports